const initState = {};

const projectReducer = (state = initState, action) => {
  switch (action.type) {
    case "CREATE_PROJECT":
      console.log("proyecto creado", action.project);
      return state;
    case "CREATE_PROJECT_ERROR":
      console.log("error al crear proyecto", action.err);
      return state;
    default:
      return state;
  }
};

export default projectReducer;
